var _defs, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAppLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 208.4,
    height: 34,
    viewBox: "0 0 208.4 34",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n\n      .cls-2 {\n        fill: #6eaff7;\n      }\n\n      .cls-3 {\n        fill: #f8cb00;\n      }\n\n      .cls-4 {\n        fill: #2b2b2b;\n      }\n\n      .cls-5 {\n        fill: #00ab47;\n      }\n\n      .cls-6 {\n        fill: #4cc87f;\n      }\n\n      .cls-7 {\n        fill: #0090a1;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m56.1,16.9c0,3,.8,5.8,2.2,8.2-2.8,4.7-7.9,7.9-13.8,7.9s-11-3.2-13.8-7.9c1.4-2.4,2.2-5.2,2.2-8.2s-.8-5.8-2.2-8.2h0c2.8-4.7,7.9-7.9,13.8-7.9s11,3.2,13.8,7.9c-1.4,2.5-2.2,5.2-2.2,8.2Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m41.4,14.1c-.3,0-.6-.3-.6-.6v-1.2c0-.3.3-.6.6-.6s.6.3.6.7v1.2c0,.3-.3.5-.6.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m47.5,14.1c-.3,0-.6-.3-.6-.6v-1.2c0-.3.3-.6.6-.6s.6.3.6.6v1.2c0,.4-.2.6-.6.6Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m32.9,16.9c0,3-.8,5.8-2.2,8.2-1.4-2.4-2.2-5.2-2.2-8.2s.8-5.8,2.2-8.2c1.3,2.5,2.2,5.3,2.2,8.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m30.6,8.8c-1.4,2.4-2.2,5.2-2.2,8.2s.8,5.8,2.2,8.2c-2.8,4.7-7.9,7.9-13.8,7.9-8.9-.1-16.1-7.3-16.1-16.2S7.9.8,16.8.8c5.9.1,11,3.2,13.8,8h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m88.2,16.9c0,8.9-7.2,16.1-16,16.1-5.9,0-11-3.2-13.8-7.9,1.4-2.4,2.2-5.2,2.2-8.2s-.8-5.8-2.2-8.2c2.8-4.7,7.9-7.9,13.8-7.9,8.8.1,16,7.3,16,16.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m16.7,25.6c-3.4,0-6.2-1.6-8.2-4.6-1.5-2.2-2-4.5-2-4.6-.1-.3.1-.6.4-.6.3-.1.6.1.6.4h0s.5,2.1,1.8,4.2c1.8,2.7,4.3,4.1,7.3,4.1s5.3-1.4,7-4.1c1.3-2.1,1.8-4.2,1.8-4.2.1-.3.4-.5.6-.4.3.1.5.4.4.6,0,.1-.5,2.3-2,4.5-1.7,3.1-4.4,4.7-7.7,4.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m49,20.6h-9c-.3,0-.5-.2-.5-.5s.2-.5.5-.5h9c.3,0,.5.2.5.5s-.2.5-.5.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m82,24.6c-.2,0-.5-.2-.5-.4h0s-.5-1.6-1.8-3.1c-1.8-2.1-4.3-3.1-7.3-3.1s-5.3,1-7.1,3.1c-1.3,1.6-1.8,3.1-1.8,3.2-.1.3-.4.5-.7.4s-.5-.4-.4-.7c0-.1.5-1.8,2-3.5,1.4-1.6,3.8-3.5,7.9-3.5s6.8,1.9,8.2,3.5c1.5,1.7,2,3.5,2,3.5.1.3-.1.6-.4.7q0-.1-.1-.1Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m60.5,16.9c0,3-.8,5.8-2.2,8.2-1.4-2.4-2.2-5.2-2.2-8.2s.8-5.8,2.2-8.2c1.4,2.5,2.2,5.2,2.2,8.2Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m69.1,14.1c-.3,0-.6-.3-.6-.6v-1.2c0-.3.3-.6.6-.6s.6.3.6.6v1.2c0,.4-.3.6-.6.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m75.2,14.1c-.3,0-.6-.3-.6-.6v-1.2c0-.3.3-.6.6-.6s.6.3.6.6v1.2c0,.4-.3.6-.6.6Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m13.7,14.1c-.3,0-.6-.3-.6-.6v-1.2c0-.3.3-.6.6-.6s.6.3.6.6v1.2c0,.4-.2.6-.6.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m19.9,14.1c-.3,0-.6-.3-.6-.6v-1.2c0-.3.3-.6.6-.6s.6.3.6.6v1.2c-.1.4-.3.6-.6.6Z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m103.9,14.1h-3.2l-5.9-13.6h3.7l3.7,9,3.7-9h3.7l-5.7,13.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m120.2,9c0,3.2-2.6,5.4-5.6,5.4s-5.7-2.2-5.7-5.4,2.6-5.4,5.7-5.4c3,.1,5.6,2.2,5.6,5.4Zm-3.1,0c0-1.6-1.2-2.6-2.5-2.6s-2.5,1.1-2.5,2.6c0,1.6,1.2,2.6,2.5,2.6,1.3.1,2.5-1,2.5-2.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m129,9.8l3,.7c-.5,2.4-2.7,4-5.2,4-3.1,0-5.6-2.2-5.6-5.4s2.5-5.4,5.6-5.4c2.5,0,4.6,1.5,5.2,3.9l-3,.7c-.3-1.2-1.1-1.8-2.2-1.8-1.5,0-2.4,1.1-2.4,2.6s1,2.6,2.4,2.6c1-.1,1.9-.6,2.2-1.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m143.7,9.9h-7.5c.3,1.2,1.1,2,2.2,2,.8,0,1.6-.2,2.2-1.2l2.9.6c-.9,2.2-2.7,3.2-5.1,3.2-3,0-5.4-2.2-5.4-5.4s2.4-5.4,5.4-5.4,5.2,2.1,5.3,5.4v.8h0Zm-7.4-2h4.2c-.3-1.1-1.1-1.6-2.1-1.6-.9,0-1.8.5-2.1,1.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m156.2,14.1h-3.3v-.8c-.8.7-1.9,1.1-3.2,1.1-2.7,0-5-2.2-5-5.4s2.3-5.4,5-5.4c1.3,0,2.4.4,3.2,1.1v-.8h3.3v10.2Zm-3.3-5.1c0-1.6-1.2-2.6-2.5-2.6-1.4,0-2.5,1.1-2.5,2.6,0,1.6,1,2.6,2.5,2.6,1.3.1,2.5-1,2.5-2.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m102.6,19.5c3.1,0,5,1.9,5,4.7s-2,4.8-5.2,4.8h-3.2v4.2h-3.4v-13.7h6.8Zm-.4,6.7c1.3,0,2.1-.8,2.1-1.9s-.8-1.9-2.1-1.9h-3v3.8h3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m120.1,33.2h-3.3v-.8c-.8.7-1.9,1.1-3.2,1.1-2.7,0-5-2.2-5-5.4s2.3-5.4,5-5.4c1.3,0,2.4.4,3.2,1.1v-.8h3.3v10.2Zm-3.2-5.1c0-1.6-1.2-2.6-2.5-2.6-1.4,0-2.5,1.1-2.5,2.6,0,1.6,1,2.6,2.5,2.6,1.3,0,2.5-1,2.5-2.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m129.6,28.9l3,.7c-.5,2.4-2.7,4-5.2,4-3.1,0-5.6-2.2-5.6-5.4s2.5-5.4,5.6-5.4c2.5,0,4.6,1.5,5.2,3.9l-3.1.7c-.3-1.2-1.1-1.8-2.2-1.8-1.5,0-2.4,1.1-2.4,2.6s1,2.6,2.4,2.6c1.1-.2,2-.7,2.3-1.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m138,20c0,1-.8,1.8-1.9,1.8s-1.9-.8-1.9-1.8.8-1.9,1.9-1.9,1.9.9,1.9,1.9Zm-3.5,13.2v-10.2h3.3v10.2h-3.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m150.3,28.9h-7.5c.3,1.2,1.1,2,2.2,2,.8,0,1.6-.2,2.2-1.2l2.9.6c-.9,2.2-2.7,3.2-5.1,3.2-3,0-5.4-2.2-5.4-5.4s2.4-5.4,5.4-5.4,5.2,2.1,5.3,5.4v.8h0Zm-7.5-2h4.2c-.3-1.1-1.1-1.6-2.1-1.6-.8,0-1.8.6-2.1,1.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m162.3,26.9v6.3h-3.2v-5.6c0-1.2-.7-2-1.8-2-1.3,0-2.1.9-2.1,2.9v4.7h-3.2v-10.2h3.3v1c.8-.8,1.9-1.3,3.1-1.3,2.3,0,3.9,1.7,3.9,4.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m172.1,32.7c-.8.4-1.6.8-2.8.8-2.5,0-4.1-1.4-4.1-4.1v-3.9h-1.9v-2.5h1.9v-3h3.3v3h3v2.6h-3v3.5c0,1.1.5,1.5,1.4,1.5.4,0,1.1-.2,1.5-.4l.7,2.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m183.4,33.2h-3.3v-1c-.8.8-1.9,1.3-3.1,1.3-2.4,0-4-1.7-4-4.3v-6.2h3.2v5.6c0,1.2.7,2,1.8,2,1.3,0,2.1-.9,2.1-2.9v-4.7h3.3v10.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m185.8,33.2v-14.7h3.3v14.7h-3.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m201.6,33.2h-3.3v-1c-.8.8-1.9,1.3-3.1,1.3-2.4,0-4-1.7-4-4.3v-6.2h3.2v5.6c0,1.2.7,2,1.8,2,1.3,0,2.1-.9,2.1-2.9v-4.7h3.3v10.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m207.6,20c0,1-.8,1.8-1.9,1.8s-1.9-.8-1.9-1.8.8-1.9,1.9-1.9c1.2,0,1.9.9,1.9,1.9Zm-3.5,13.2v-10.2h3.3v10.2h-3.3Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppLogo);
export default __webpack_public_path__ + "static/media/app-logo.68993cfe443d70c2414890f94eb84865.svg";
export { ForwardRef as ReactComponent };